import styled from 'styled-components'

export const BaseWrapper = styled.div<{
  $flexDirection?: 'column' | 'row'
  $maxHeight?: string
  $height?: string
  $padding?: string
  $justifyLeftContent?: string
}>`
  display: flex;
  flex-direction: ${({ $flexDirection }) => $flexDirection || 'row'};
  flex: 1;
  max-height: ${({ $maxHeight }) => $maxHeight || '100%'};
  height: ${({ $height }) => $height || 'auto'};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    .right {
      margin-top: 1rem;
      justify-content: flex-start;
    }
  }

  .children-options {
    flex: 1;
    overflow-x: hidden;
    overflow-y: scroll;

    .children-option {
      display: flex;
      position: relative;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 1rem;
      cursor: pointer;

      &:not(:last-child)::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        display: block;
        margin-left: 1rem;
        border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};
        width: 100%;
      }

      &:hover {
        background-color: ${({ theme }) => theme.colors.lightGrey};

        &:last-child {
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        }
      }

      &.is-selected,
      &.is-selected:hover {
        background-color: ${({ theme }) => theme.colors.lightGrey};
      }

      .left {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;

        .title {
          font-weight: bold;

          svg {
            color: ${({ theme }) => theme.colors.primary};
          }
        }
      }

      @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
        flex-direction: column;
        align-items: flex-start;

        .right {
          margin-top: 1rem;
          justify-content: flex-start;
        }
      }
    }
  }

  .left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: ${({ $justifyLeftContent }) => $justifyLeftContent || 'flex-start'};

    .title {
      font-weight: bold;

      svg {
        color: ${({ theme }) => theme.colors.primary};
      }
    }
  }

  .right {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .alert {
      padding: 0.3rem 1rem;
      border-radius: 8px;
      margin-right: 0.3rem;
      text-transform: uppercase;
      font-weight: bold;
      max-width: 200px;
      text-align: center;

      @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
        width: 100%;
        max-width: none;
      }
    }

    .button {
      user-select: none;
      cursor: pointer;
      background-color: ${({ theme }) => theme.colors.lightGrey};
      padding: 0.3rem 1rem;
      border-radius: 8px;
      margin-right: 0.3rem;
      border: none;
      white-space: nowrap;
    }
  }
  .cards {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;

    .card {
      display: flex;
      position: relative;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 1rem;
      cursor: pointer;

      @media (min-width: ${({ theme }) => theme.breakpoints.mobile}px) {
        &[data-selected='true'] {
          background-color: ${({ theme }) => theme.colors.lightGrey};
        }
      }

      &:not(:last-child)::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        display: block;
        margin-left: 1rem;
        border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};
        width: 100%;
      }

      &:hover {
        background-color: ${({ theme }) => theme.colors.lightGrey};

        &:last-child {
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        }
      }
    }
  }
`
